// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","hr":"Footer_hr__tPoOf","logo":"Footer_logo__+JiYo","dark":"Footer_dark__gZc5I"};